<template>
  <div class="bg-white mt-5 rounded p-3 px-5">
    <div class="w-full flex flex-col md:flex-row border-b py-5 mb-6">
      <div
        class="w-32 h-32 p-4 -mt-20 ml-2 mb-2 text-white rounded-lg relative flex-no-shrink bg-pl-aqua mr-5" >
        <icon name="email"></icon>
      </div>

      <div class="w-full flex justify-between">
        <div class="w-full flex items-start">
          <h1 class="text-xl self-end mb-3 uppercase font-medium">{{ this.title }}</h1>
        </div>
        <div class="w-full flex flex-col"></div>
      </div>
    </div>
    <div v-if="! this.isLoading" class="flex flex-col">
      <div class="w-full border-b border-gray-400 mb-2">
        <div class="flex">
          <div class="lg:w-2/5 w-full overflow-x-hidden p-4">
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">Subject Title:</label>
              <input v-model="subject" class="border rounded p-2 w-full mb-2" :class="hasError && subject === '' ? 'border-red' : 'border-gray-dark'" placeholder="Subject Title" />
              <span v-if="hasError && subject === ''" class="mt-2 text-red">This field cannot be empty</span>
            </div>
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">Name of Recipient:</label>
              <input v-model="vendorName" class="border rounded p-2 w-full mb-2" :class="hasError && vendorName === '' ? 'border-red' : 'border-gray-dark'" placeholder="Name of Recipient" />
              <span v-if="hasError && vendorName === ''" class="mt-2 text-red">This field cannot be empty</span>
            </div>
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">Recipient's Email Address:</label>
              <input v-model="vendorEmail" class="border rounded p-2 w-full mb-2" :class="hasError && vendorEmail === '' ? 'border-red' : 'border-gray-dark'" placeholder="john.doe@example.com" />
              <span v-if="hasError && vendorEmail === ''" class="mt-2 text-red">This field cannot be empty</span>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('to')" v-text="errorBag.get('to')"></small>
            </div>
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">CC Email Address:</label>
              <input v-model="vendorCcEmail" class="border rounded p-2 w-full mb-2" :class="hasError === '' ? 'border-red' : 'border-gray-dark'" placeholder="john.doe@example.com" />
              <span class="mt-2 text-xs">Please separate email addresses with a semicolon.</span>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('cc')" v-text="errorBag.get('cc')"></small>
            </div>
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">Bcc Email Address:</label>
              <input v-model="vendorBccEmail" class="border rounded p-2 w-full mb-2" :class="hasError === '' ? 'border-red' : 'border-gray-dark'" placeholder="john.doe@example.com" />
              <span class="mt-2 text-xs">Please separate email addresses with a semicolon.</span>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('bcc')" v-text="errorBag.get('bcc')"></small>
            </div>
            <div class="mb-8 w-full">
              <label class="block font-bold mb-2">Address of Property:</label>
              <input v-model="propertyAddress" class="border p-2 w-full mb-2" :class="hasError && propertyAddress === '' ? 'border-red' : 'border-gray-dark'" placeholder="Address of Property" />
              <span v-if="hasError && propertyAddress === ''" class="mt-2 text-red">This field cannot be empty</span>
            </div>
            <div class="mb-8 w-full" v-if="this.type === 'pre'">
              <label class="block font-bold mb-2">Appointment Date:</label>
              <date-time-picker
                v-model="appointmentDate"
                lang="en"
                :type="'datetime'"
                :minute-step="5"
                @change="formatAppointmentDate(appointmentDate)"
                format="dd/MM/yyyy hh:mma"
                width="100%"
                input-class="w-full border border-grey-dark p-2 rounded mt-2"
                :editable="true"
              />
            </div>
            <div class="mt-8 mb-4">
              <div class="border-t border-black w-full mb-8"></div>
              <div>
                <strong>Edit Email Content:</strong>
              </div>
            </div>
            <div class="mb-8" v-if="type === 'pre'">
              <textarea class="w-full border border-grey-dark rounded p-2" rows="3" v-model="templateData.appointment"></textarea>
            </div>
            <div class="mb-8" v-if="type === 'post'">
              <textarea class="w-full border border-grey-dark rounded p-2" rows="3" v-model="templateData.recap"></textarea>
            </div>
<!--            <div class="mb-8 px-2 text-sm text-blue-light flex items-center font-bold">
              <icon class="fill-current text-green" style="margin: 0 !important;height:1rem;width:1rem;margin-left:-.5rem;margin-bottom: -1em" name="calendar_2"></icon>
              <small class="text-green ml-1">APPOINTMENT DATE added automatically</small>
            </div>-->
            <div class="mb-3">
              <input type="radio" id="defaultVideo" name="videoType" v-model="isCustomVideo" :value="false" />
              <label for="defaultVideo" :class="!isCustomVideo ? 'border-b-white text-black' : 'text-grey bg-grey-lighter'">
                Use Guild Provided Video
              </label>
            </div>
            <div class="mb-3">
              <input type="radio" id="customVideo" name="videoType" v-model="isCustomVideo" :value="true" />
              <label for="customVideo" :class="isCustomVideo ? 'border-b-white text-black' : 'text-grey bg-grey-lighter'">
                Use Custom Video
              </label>
              <div class="flex flex-wrap -mx-2" v-if="isCustomVideo">
                <valuation-video :video-name="type+'_'+department" :type="type" :department="department" :video-url="customVideoURL" :video-size="cunstomVideoSize"
                  :video-thumbnail="customVideoThumbnail" @thumbnailUpdated="updateCustomVideoThumbnail" @customVideoUpdated="updateCustomVideo"></valuation-video>
              </div>
            </div>
            <strong class="my-4">Body Text</strong>

            <div class="mb-8">
              <tinymce
                :init="editorConfig"
                v-model="templateData.contents"
                @onChange="onTinyMceContentChange"
              />
            </div>
            <div class="mb-8 flex flex-col">
              <strong class="mb-2">Agent / Contact Name:</strong>
              <input class="border border-grey-dark rounded p-2" v-model="contactName" type="text" />
            </div>
            <div class="mb-8 flex flex-col">
              <strong class="mb-2">Telephone Number:</strong>
              <input class="border border-grey-dark rounded p-2" v-model="office_contact" type="text" />
            </div>
            <div class="mb-8 flex flex-col">
              <input class="border" id="one" type="radio" v-model="picked" :value="profile.email" />
              <label class="mb-3" for="one">
                {{profile.email}}
              </label>
              <input v-if="this.department === 'rl'" type="radio" id="two" v-model="picked" :value="selectedOffice.lettings_email ? selectedOffice.lettings_email : selectedOffice.sales_email" />
              <input v-if="this.department === 'rs'" type="radio" id="two" v-model="picked" :value="selectedOffice.sales_email ? selectedOffice.sales_email : selectedOffice.lettings_email" />
              <label for="two" v-if="this.department === 'rl'">
                {{selectedOffice.lettings_email ? selectedOffice.lettings_email : selectedOffice.sales_email}}
              </label>
              <label for="two" v-if="this.department === 'rs'">
                {{selectedOffice.sales_email ? selectedOffice.sales_email : selectedOffice.lettings_email}}
              </label>
            </div>
          </div>
          <div class="lg:w-3/5 w-full email-container overflow-x-hidden p-4">
            <div class="bg-grey-lightest p-8 mb-8">
              <table class="mx-auto bg-white" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing:0;">
                <thead>
                <tr>
                  <th width="350" valign="middle" :bgcolor="style.colour1_mailers ? style.colour1_mailers : style.colour1 ? style.colour1 : 'white'" :style="{ backgroundColor: style.colour1_mailers ? style.color1_mailers : style.colour1 ? style.colour1 : 'white', maxWidth:'300px !important', verticalAlign:'middle',padding:'10px'}">
                  </th>
                  <th width="250" :bgcolor="style.colour1_mailers ? style.colour1_mailers : style.colour1 ? style.colour1 : 'white'" :style="{ backgroundColor: style.colour1_mailers ? style.colour1_mailers : style.colour1 ? style.colour1 : 'white', maxWidth:'300px !important', padding:'10px'}">

                  </th>
                </tr>
                <tr>
                  <th style="padding-left: 20px;padding-bottom:20px" v-if="this.type === 'post'">
                    <h1 style="text-align:left;margin-bottom:10px;padding-top:15px;font-size:22px">Thank You</h1>
                    <h3 style="text-align:left;">for the opportunity to value your home</h3>
                  </th>
                  <th style="padding-left: 20px;padding-bottom:20px" v-else>
                    <h1 style="text-align:left;margin-bottom:10px;padding-top:15px;font-size:22px">Confirmation of Appointment</h1>
                  </th>
                  <th style="padding-right:20px;padding-bottom:20px">
                    <div style="width:100%;height:100%;top:0;padding-top:10%;max-width:300px!important;text-align:right">
                      <img style="margin:0;padding:0;" :src=" style.logo_mailers_url ? style.logo_mailers_url : style.logo_url ?  style.logo_url : 'https://static.eprop.services/members-media/emails/epropservices-logo.jpg' " width="150px" class="logo" />
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="2" style="padding-bottom: 10px; padding-left: 20px; padding-right: 20px">
                    Dear {{vendorName}}
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-bottom: 10px; padding-left: 20px; padding-right: 20px">
                    <strong>{{propertyAddress}}</strong>
                  </td>
                </tr>
                <tr v-if="this.type === 'pre'">
                  <td colspan="2" style="padding-bottom: 10px; padding-left: 20px; padding-right: 20px">
                    <p>{{templateData.appointment}}</p>
                    <p><strong>{{ appointmentDate | date(false) }} at {{ appointmentDate | time12hr(false) }}</strong></p><br/>
                    <p>Please take a moment to watch this video before we meet.</p><br/>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-bottom: 10px; padding-left: 20px; padding-right: 20px" v-if="!isCustomVideo">
                    <p style="padding-bottom:15px" v-if="this.type === 'post'">{{templateData.recap}}</p>
                    <div class="text-center">
                      <a href="https://www.guildproperty.co.uk/post-valuation" v-if="this.type === 'post' && this.department === 'rs'">
                        <img src="https://static.propertylogic.net/members-media/system/2/post_val.png" height="175" width="100%" />
                      </a>
                      <a href="https://www.guildproperty.co.uk/pre-valuation" v-if="this.type === 'pre' && this.department === 'rs'">
                        <img src="https://static.propertylogic.net/members-media/system/2/pre_val.png" height="175" width="100%" />
                      </a>
                      <a href="https://www.guildproperty.co.uk/lettings-post-valuation" v-if="this.type === 'post' && this.department === 'rl'">
                        <img src="https://static.propertylogic.net/members-media/system/2/post_val.png" height="175" width="100%" />
                      </a>
                      <a href="https://www.guildproperty.co.uk/lettings-pre-valuation" v-if="this.type === 'pre' && this.department === 'rl'">
                        <img src="https://static.propertylogic.net/members-media/system/2/pre_val.png" height="175" width="100%" />
                      </a>
                    </div>
                  </td>
                  <td colspan="2" style="padding-bottom: 10px; padding-left: 20px; padding-right: 20px" v-else>
                    <p style="padding-bottom:15px" v-if="this.type === 'post'">{{templateData.recap}}</p>
                    <div class="text-center">
                      <a :href="customVideoURL">
                        <img :src="customVideoThumbnail" v-if="customVideoThumbnail" height="175" width="100%" />
                        <div class="border p-4" v-else>Click to view Video</div>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-top:10px; padding-left: 20px; padding-right: 20px">
                    <div id="email-content" v-html="templateData.contents"></div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-top:10px;padding-left:20px;padding-right:20px;padding-bottom:10px">
                    Yours sincerely,
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px">
                    <strong>{{contactName}}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-bottom:10px;padding-left:20px;padding-right:20px;padding-top:10px">
                    <p>Tel:<strong style="padding-left:10px">{{office_contact}}</strong></p>
                    <p>Email:<strong style="padding-left:10px">{{picked}}</strong></p>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td colspan="2" style="padding-left:20px;padding-right:20px">
                    <div style="width:100%;border-top:1px solid black"></div>
                  </td>
                </tr>
                <tr style="">
                  <td style="padding-left:20px;padding-top:10px;padding-right:10px">
                    {{ selectedOffice.name }}, {{selectedOffice.address_name_number}}{{selectedOffice.address_line2 ? ' ' + selectedOffice.address_line2 + ',': ''}}{{selectedOffice.address_line3 ? ' ' + selectedOffice.address_line3 + ',' : ''}}{{! selectedOffice.address_line2 && ! selectedOffice.address_line3 ? ',' : ''}} {{selectedOffice.address_town ? selectedOffice.address_town + ',' : ''}} {{selectedOffice.address_postcode ? selectedOffice.address_postcode : ''}}
                  </td>
                  <td style="padding-right:20px;padding-top:20px;text-align:right">
                    <a href="https://www.guildproperty.co.uk/" target="_blank">
                    <img src="https://services-media.propertylogic.net/website/1484824538/logo/logo.png" height="120" width="120" style="padding-left:30px" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left:20px;padding-bottom:20px">
                    <a style="color:inherit;text-decoration:none" :href="selectedOffice.website" target="_blank" rel="noopener noreferrer">{{selectedOffice.website}}</a>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" :bgcolor="style.colour1_mailers ? style.colour1_mailers : style.colour1 ? style.colour1 : 'white'" :style="{ backgroundColor: style.colour1_mailers ? style.colour1_mailers : style.colour1 ? style.colour1 : 'white', padding:'15px'}">
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>
            <div>
              <button :disabled="sendingMail" @click="sendMail" class="bg-secondary w-full text-primary rounded py-3 text-sm font-medium hover:text-white mb-8">
                <span v-if="sendingMail"><loader/></span>
                <div class="flex flex-row items-center justify-center" v-else>
                  <div class="w-8 h-8 mr-2 fill-current" v-html="require(`@/assets/icons/paper_plane.svg`)"></div>
                  <span>
                    Send Email
                  </span>
                </div>
              </button>
              <div class="w-full flex">
                <div class="w-1/2 text-center">
                  <button class="text-xs hover:text-blue" v-if="isSaving">
                    <span><loader/></span>
                  </button>
                  <button @click="saveDefaultMail" class="underline text-xs hover:text-blue" :class="save ? 'text-blue-light' : 'text-grey-dark'" v-else>
                    Save as my default email
                  </button>
                </div>
                <div class="w-1/2 text-center">
                  <button class="text-xs hover:text-blue" v-if="isReverting">
                    <span><loader/></span>
                  </button>
                  <button @click="revertDefaultMail" class="underline text-xs hover:text-blue" :class="revert ? 'text-blue-light' : 'text-grey-dark'" v-else>
                    Revert to Guild default
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader v-else />
  </div>
</template>

<script>
import mceConfig from '@/mixins/StrippedTinyMCE'
import ErrorBag from '@/ErrorBag'
import api from '@/http'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import DateTimePicker from 'vue-vanilla-datetime-picker'

export default {
  name: 'CommonValuationEmailManager',
  props: {
    type: String, // pre or post
    department: String,
    title: String
  },
  mixins: [ mceConfig ],
  components: { DateTimePicker },
  computed: {
    ...mapState(['selectedOffice', 'profile']),
    mutableTemplateData: {
      get: function () {
        return this.templateData
      },
      set: function (e) {
        this.templateData = e
      }
    }
  },
  data () {
    return {
      isLoading: true,
      isSaving: false,
      isReverting: false,
      templateData: {},
      hasErrored: false,
      vendorName: '',
      vendorEmail: '',
      vendorCcEmail: '',
      vendorBccEmail: '',
      propertyAddress: '',
      contactName: '',
      original: '',
      sendingMail: false,
      picked: this.$store.state.profile.email,
      appointmentDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      office_name: this.$store.state.selectedOffice.name,
      office_contact: (this.department === 'rl' ? (this.$store.state.selectedOffice.lettings_phone ? this.$store.state.selectedOffice.lettings_phone : this.$store.state.selectedOffice.sales_phone) : this.$store.state.selectedOffice.sales_phone).replace(/ /g, ''),
      style: {},
      save: false,
      revert: false,
      hasError: false,
      errorBag: new ErrorBag(),
      isCustomVideo: false,
      customVideoURL: null,
      customVideoThumbnail: null,
      cunstomVideoSize: null
    }
  },
  mounted () {
    this.fetchTemplateData()
    this.setupData()
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    fetchTemplateData () {
      this.isLoading = true
      api.get(`/valuation-mail/get-template/${this.selectedOffice.id}/${this.type}/${this.department}`)
        .then(response => {
          this.isLoading = false
          this.isSaving = false
          this.style = response.data.style

          if (typeof response.data.content === 'string') {
            this.original = response.data.content
            this.templateData = JSON.parse(response.data.content)
            this.templateData.contents = this.templateData.length ? this.templateData.contents.replace('[YOUR_COMPANY_NAME]', this.selectedOffice.name) : ''
            this.templateData.contents = this.templateData.length ? this.templateData.contents.replace('[YOUR_CONTACT_NUMBER]', this.selectedOffice.lettings_phone ? this.selectedOffice.lettings_phone : this.selectedOffice.sales_phone) : ''
          } else {
            this.original = JSON.stringify(response.data.content)
            this.templateData = response.data.content
            this.templateData.contents = this.templateData.contents.replace('[YOUR_COMPANY_NAME]', this.selectedOffice.name)
            this.templateData.contents = this.templateData.contents.replace('[YOUR_CONTACT_NUMBER]', this.selectedOffice.lettings_phone ? this.selectedOffice.lettings_phone : this.selectedOffice.sales_phone)
          }
          this.isCustomVideo = response.data.custom_video_flag
          this.customVideoURL = response.data.custom_video_url
          this.customVideoThumbnail = response.data.custom_video_thumbnail
          this.cunstomVideoSize = response.data.custom_video_size
        })
        .catch(() => {
          this.isLoading = false
          this.hasErrored = true
        })
    },
    setupData () {
      this.contactName = this.profile.name
      this.subject = this.type === 'pre' ? 'Your Appointment Confirmation' : 'Thank You for Your Time'
    },
    formatAppointmentDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    saveDefaultMail () {
      let emailDefaultData = {
        contactName: this.contactName,
        office_name: this.office_name,
        office_email: this.picked,
        office_contact: this.office_contact
      }
      this.isSaving = true
      this.isReverting = false

      this.templateData.contactName = this.contactName

      let saveNewData = Object.assign(emailDefaultData, this.templateData)
      api.post(`/valuation-mail/save/default/${this.selectedOffice.id}/${this.type}/${this.department}`, {
        content: saveNewData
      })
        .then(response => {
          this.sendingMail = false
          this.isSaving = false
          this.isReverting = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Success',
            info: `Default Email has been saved successfully.`
          })
        })
        .catch(() => {
          this.sendingMail = false
          this.isSaving = false
          this.isReverting = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Error',
            info: `There was an error saving default mail.`
          })
        })
    },
    revertDefaultMail () {
      this.isReverting = true
      api.delete(`/valuation-mail/revert/default/${this.selectedOffice.id}/${this.type}/${this.department}`)
        .then(response => {
          this.sendingMail = false
          this.fetchTemplateData()
          this.isReverting = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Success',
            info: `Default Email has been reverted successfully.`
          })
        })
        .catch(() => {
          this.sendingMail = false
          this.isReverting = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Error',
            info: `There was an error reverting the default mail.`
          })
        })
    },
    sendMail () {
      this.errorBag.clear()
      this.sendingMail = true
      this.hasError = false

      if (this.vendorName === '' || this.vendorEmail === '' || this.propertyAddress === '') {
        this.sendingMail = false
        this.hasError = true
        return this.displayToastNotification({
          type: 'warning',
          icon: 'fa-bell',
          title: 'Invalid Data',
          info: `One or more field is empty. Please check.`
        })
      }

      this.templateData.vendorName = this.vendorName
      this.templateData.propertyAddress = this.propertyAddress
      this.templateData.date = this.appointmentDate

      let emailData = {
        vendorName: this.vendorName,
        vendorCcEmail: this.vendorCcEmail,
        vendorBccEmail: this.vendorBccEmail,
        propertyAddress: this.propertyAddress,
        date: this.appointmentDate,
        contactName: this.contactName,
        office_name: this.office_name,
        office_email: this.picked,
        office_contact: this.office_contact
      }

      let newData = Object.assign(emailData, this.templateData)

      let videoInfo = {}
      if (this.isCustomVideo) {
        videoInfo = {
          'url': this.customVideoURL,
          'thumbnail': this.customVideoThumbnail
        }
      }
      api.post(`/valuation-mail/send/mail/${this.selectedOffice.id}/${this.type}/${this.department}`, {
        content: newData,
        videoInfo: videoInfo,
        to: this.vendorEmail,
        cc: this.vendorCcEmail,
        bcc: this.vendorBccEmail,
        from: this.picked ? this.picked : this.profile.email,
        subject: this.subject
      })
        .then(response => {
          this.sendingMail = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Success',
            info: `Email has been sent successfully.`
          })
        })
        .catch((error) => {
          this.sendingMail = false
          if (error.response.status === 422) {
            this.errorBag.store(error.response.data)
          }
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Error',
            info: error.response.data.message
          })
        })
    },
    toggleRevert () {
      this.revert = !this.revert
      this.save = false
      this.fetchTemplateData()
      return this.displayToastNotification({
        type: 'success',
        icon: 'fa-check',
        title: 'Reverted Content',
        info: `We've reverted your content back to the guild default.`
      })
    },
    updateCustomVideo (videoUrl) {
      this.customVideoURL = videoUrl
    },
    updateCustomVideoThumbnail (thumbnail) {
      this.customVideoThumbnail = thumbnail
    },
    onTinyMceContentChange (event, editor) {
      let content = editor.getContent()
      let emptyListItem = '<li>&nbsp;</li>'
      if (content.includes('mce-toc') && content.includes(emptyListItem)) {
        content = content.replace(new RegExp(emptyListItem, 'g'), '')
        if (typeof content === 'string' && content.length !== 0) {
          editor.setContent(content)
        }
      }
    }
  },
  watch: {
    selectedOffice () {
      this.fetchTemplateData()
      this.office_contact = (this.$store.state.selectedOffice.lettings_phone ? this.$store.state.selectedOffice.lettings_phone : this.$store.state.selectedOffice.sales_phone).replace(/ /g, '')
    }
  }
}
</script>
<style>
/* Add to override Tailwind */
#email-content p {
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
